export default {
  SUBSCRIBE_PRODUCT_FETCHED: 'SUBSCRIBE_PRODUCT_FETCHED',
  SUBSCRIBE_PRODUCT_LOAD: 'SUBSCRIBE_PRODUCT_LOAD',
  SUBSCRIBE_PRODUCT_TEMPLATES_FETCHED: 'SUBSCRIBE_PRODUCT_TEMPLATES_FETCHED',
  SUBSCRIBE_PRODUCT_TEMPLATES_LOAD: 'SUBSCRIBE_PRODUCT_TEMPLATES_LOAD',
  SUBSCRIBE_PRODUCT_DETAIL: 'SUBSCRIBE_PRODUCT_DETAIL',
  SUBSCRIBE_PRODUCT_BUTTON_LOAD: 'SUBSCRIBE_PRODUCT_BUTTON_LOAD',
  USERS_SUBSCRIPTION_ACTIONS_LOAD: 'USERS_SUBSCRIPTION_ACTIONS_LOAD',
  USERS_SUBSCRIPTION_ACTIONS_FETCHED: 'USERS_SUBSCRIPTION_ACTIONS_FETCHED',
};
